import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { Column } from '../contexts/column.context';
import { Plot } from '../contexts/plot.context';
import { Row } from '../contexts/row.context';
import { Strip } from '../contexts/strip.context';
import { MINUTE, squareToPixel, STRIP_WIDTH } from '../utils/graph.utils';
import { Calibration } from './Calibration';
import { CalibrationContainer } from './CalibrationContainer';
import { MinuteGraph } from './MinuteGraph';
import { StripEditor } from './StripEditor';

const CONTEXT_PLOT_HEIGHT = squareToPixel(1);
const CONTEXT_DURATION = 60_000; // 60s

type Props = {
  onset?: number;
  offset?: number;
  duration?: number;
  children?: ReactNode;
};

export const MINUTE_STRIP_ID = `${MINUTE}-strip`;

export const MinutePlot = ({
  onset = 0,
  offset = 0,
  duration = CONTEXT_DURATION,
  children,
}: Props) => {
  const leads = useSelector(leadNamesSelector);
  const minutePlotDuration =
    duration + onset + offset > CONTEXT_DURATION
      ? duration + onset + offset
      : CONTEXT_DURATION;

  return (
    <Strip
      id={MINUTE_STRIP_ID}
      duration={minutePlotDuration}
      leads={leads.slice(0, 1)}
      onset={onset}
      offset={offset}
    >
      <Plot>
        <Row height={CONTEXT_PLOT_HEIGHT}>
          <StripEditor>
            <CalibrationContainer>
              <Calibration />
            </CalibrationContainer>
          </StripEditor>
          <Column width={STRIP_WIDTH}>
            <MinuteGraph />
          </Column>
        </Row>
      </Plot>
      {children}
    </Strip>
  );
};
